import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import loadViewData from "@tSurya/Handlers/ViewReturnData";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import SuryaPageThemeWrapper from "@tSurya/Utils/SuryaPageThemeWrapper";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}
const mapStateToProps = (state: CustomApplicationState) => {
    return {
        pagination: state.SURData.viewDataStore.pagination,
        serachedParameter: state.SURData.viewDataStore.searchparameter,
    };
};

const mapDispatchToProps = {
    loadViewData,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const paginationStyles: PaginationStyles = {};

const styles = paginationStyles;

const SurViewReturnsFilterFormPagination: FC<Props> = ({ loadViewData, pagination, serachedParameter }) => {
    if (!pagination) {
        return null;
    }

    const { totalItemCount, page, pageSize, pageSizeOptions } = pagination;

    if (totalItemCount === 0) {
        return null;
    }

    const changePage = (newPageIndex: number) => {
        loadViewData({
            ...serachedParameter,
            page: newPageIndex,
        });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);

        loadViewData({
            ...serachedParameter,
            pageSize: newPageSize,
        });
    };

    return (
        <SuryaPageThemeWrapper>
            <Pagination
                {...styles.pagination}
                resultsCount={totalItemCount}
                currentPage={page}
                resultsPerPage={pageSize}
                resultsPerPageOptions={pageSizeOptions}
                onChangePage={changePage}
                onChangeResultsPerPage={changeResultsPerPage}
                pageSizeCookie="SurViewReturnsFilterFormData-PageSize"
            />
        </SuryaPageThemeWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SurViewReturnsFilterFormPagination),
    definition: {
        displayName: "SurViewReturnsFilterFormPagination",
        group: "Common",
    },
};

export default widgetModule;
